export var agodaIllustrations = {
    "placeholder.image.error": "a8427f25",
    "placeholder.image.loading": "1bda4ba7"
};
export var defaultIllustrations = {
    "placeholder.image.error": "ff40e917",
    "placeholder.image.loading": "201fb8ca"
};
